import { useEffect, useState } from 'react';
import { Memory } from '../../core/Memory';
//import _ from 'lodash';

export const useTheme = () => {
    const baseTheme = {
        "primary": "#70bf44", 
        "tertiary": "#cdf284", 
        "secondary": "#3c4b64",
        "light": "#f7f7f7",
        "dark": "#333",
        "gray": "#b2b7c1",
        "app-bg-color": "#000",
        "app-bg-image": "https://images.marketpath.com/fd7889fd-dac4-4f8a-87ef-c6ca38ae7aae/image/f9c66ec7-24e2-4c51-a4d6-a6dfa7f85986/bg_transp.webp",
        "app-bg-position": "0 50%",
        "header-bg": "#000000F0",
        /*// Reactstrap Colors
        "r-primary": "#007bff",
        "r-secondary": "#6c757d",
        "r-success": "#28a745",
        "r-danger": "#dc3545",
        "r-warning": "#ffc107",
        "r-info": "#ffc107",
        "r-light": "#f8f9fa",
        "r-dark": "#343a40",
        "r-lt-yellow": "#fae8b1",
        "r-lt-gray": "#f5f5f5",
        "r-md-gray": "#dedede",
        "overlay-img": "https://images.marketpath.com/fd7889fd-dac4-4f8a-87ef-c6ca38ae7aae/image/fb551120-f984-4826-920b-ac37048c5f78/ScaryFastLogoTransparent.png",*/

        "bg-img": "https://images.marketpath.com/fd7889fd-dac4-4f8a-87ef-c6ca38ae7aae/image/f9c66ec7-24e2-4c51-a4d6-a6dfa7f85986/bg_transp.webp",
        "logo-img": "https://images.marketpath.com/fd7889fd-dac4-4f8a-87ef-c6ca38ae7aae/image/fb551120-f984-4826-920b-ac37048c5f78/ScaryFastLogoTransparent.png"
    };
    const [theme, setTheme] = useState(baseTheme);
    const [themeLoaded, setThemeLoaded] = useState(false);

    const setMode = mode => {
        Memory.saveObject('theme', mode)
        setTheme(mode);
    };

  /*const getFonts = () => {
    const allFonts = _.values(_.mapValues(themes.data, 'font'));
    return allFonts;
  }*/

  useEffect(() =>{
    const localTheme = Memory.getString('theme');
    localTheme ? setTheme(localTheme) : setTheme(baseTheme);
    setThemeLoaded(true);
  }, []);

  return { theme, themeLoaded, setMode, /*getFonts */ };
};